export default __webpack_public_path__ + "static/media/nossas_lojas.79f38095.jpg";